import { useSelector } from 'react-redux'
import { isTown } from '../../store/address/address.helpers'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { getPostCodeFromTown } from './seo'

const useFirstAddressWithTownSeoPostcode = () => {
  const address = useSelector(selectFirstAddress)
  if (isTown(address)) {
    const cityWithDistrictPostcode = getPostCodeFromTown(address.town)
    if (cityWithDistrictPostcode) return { ...address, postcode: cityWithDistrictPostcode }
  }
  return address
}

export default useFirstAddressWithTownSeoPostcode
